'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _TargetDateSeriesIssueLink = require('./TargetDateSeriesIssueLink.css');

var _TargetDateSeriesIssueLink2 = _interopRequireDefault(_TargetDateSeriesIssueLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TargetDateSeriesIssueLink = (_dec = (0, _reactCssModules2.default)(_TargetDateSeriesIssueLink2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TargetDateSeriesIssueLink, _Component);

  function TargetDateSeriesIssueLink(props) {
    (0, _classCallCheck3.default)(this, TargetDateSeriesIssueLink);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TargetDateSeriesIssueLink.__proto__ || (0, _getPrototypeOf2.default)(TargetDateSeriesIssueLink)).call(this, props));

    var iyvCode = props.iyvCode;


    _this.state = _this.getIssueLinkState(iyvCode);
    return _this;
  }

  (0, _createClass3.default)(TargetDateSeriesIssueLink, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState(this.getIssueLinkState(props.iyvCode));
    }
  }, {
    key: 'getIssueLinkState',
    value: function getIssueLinkState(iyvCode) {
      var issueUrl = null;
      var issueTagline = null;
      switch (iyvCode) {
        case 'fff':
          issueUrl = _config2.default.routes.issueFossilFuels;
          issueTagline = 'Learn how asset managers fuel climate destruction';
          break;

        case 'dff':
          issueUrl = _config2.default.routes.issueDeforestation;
          issueTagline = 'Learn how asset managers fund deforestation';
          break;

        case 'ffb':
          issueUrl = _config2.default.routes.issueFossilFuelFinanceInsurance;
          issueTagline = 'Learn how banks financially support fossil fuels';
          break;

        case 'ffi':
          issueUrl = _config2.default.routes.issueFossilFuelFinanceInsurance;
          issueTagline = 'Learn how insurers financially support fossil fuels';
          break;

        case 'gef':
          issueUrl = _config2.default.routes.issueGenderEquality;
          issueTagline = 'Learn how asset managers invest in gender inequality';
          break;

        case 'gff':
          issueUrl = _config2.default.routes.issueCivilianFirearms;
          issueTagline = 'Learn how asset managers fund gun violence';
          break;

        case 'pff':
          issueUrl = _config2.default.routes.issuePrisonIndustrialComplex;
          issueTagline = 'Learn how asset managers fund the prison industrial complex';
          break;

        case 'wff':
          issueUrl = _config2.default.routes.issueArmsManufacturers;
          issueTagline = 'Learn how asset managers fund arms manufacturers';
          break;

        case 'tff':
          issueUrl = _config2.default.routes.issueTobacco;
          issueTagline = 'Learn how asset managers fund tobacco';
          break;
      }

      return {
        issueUrl: issueUrl,
        issueTagline: issueTagline
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          issueUrl = _state.issueUrl,
          issueTagline = _state.issueTagline;

      if (!issueUrl || !issueTagline) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'companies-methodology-link' },
        _react2.default.createElement(
          'span',
          null,
          'The issues'
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _components.Link,
            {
              to: issueUrl,
              title: issueTagline,
              xstrong: true
            },
            issueTagline
          )
        )
      );
    }
  }]);
  return TargetDateSeriesIssueLink;
}(_react.Component), _class2.propTypes = {
  // three letters, fff/dff/gef/gff/pff/wff/tff
  iyvCode: _react.PropTypes.string.isRequired
}, _temp)) || _class);
exports.default = TargetDateSeriesIssueLink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TargetDateSeriesIssueLink/TargetDateSeriesIssueLink.js
// module id = 1451
// module chunks = 0